import {createProvider} from './vue-apollo'
export const apolloProvider = createProvider()
export const apolloClient = apolloProvider.defaultClient
